import { z } from 'zod';

export const mailAntivirusConfigSchema = z.object({
  enabled: z.boolean(),
  serviceName: z.string().trim().min(1).max(100).regex(/^[a-zA-Z0-9][a-zA-Z0-9_.-]*$/),
  sshHostKeySha256: z.string().regex(/^(?:[a-f0-9]{64})?$/),
}).strict().refine(value => !value.enabled || value.sshHostKeySha256.length === 64, {
  message: 'Verify the server SSH fingerprint before enabling monitoring', path: ['sshHostKeySha256'],
});
export type MailAntivirusConfig = z.infer<typeof mailAntivirusConfigSchema>;
export const MAIL_ANTIVIRUS_ERRORS = ['service_missing', 'service_ambiguous', 'host_unavailable', 'container_missing', 'unhealthy', 'stale', 'health_unknown'] as const;
export type MailAntivirusError = typeof MAIL_ANTIVIRUS_ERRORS[number];
export interface MailAntivirusDto {
  config: MailAntivirusConfig;
  running: boolean;
  status: 'disabled' | 'unknown' | 'healthy' | 'degraded' | 'down' | 'overdue';
  lastCheckedAt: string | null;
  error: MailAntivirusError | null;
}
